import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Scroll to top on initial page load
if (typeof window !== 'undefined') {
  window.scrollTo(0, 0);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Defer web vitals reporting to reduce initial JavaScript execution
if (typeof window !== 'undefined') {
  const scheduleReport = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => reportWebVitals(), { timeout: 2000 });
    } else {
      setTimeout(() => reportWebVitals(), 2000);
    }
  };
  scheduleReport();
}
